/**
 * CyBoard App Configuration (centralized)
 * Single source of truth for app-level constants that appear in the UI.
 * Never hardcode these values elsewhere.
 */

export const SUPPORT_EMAIL = 'support@cyboard.games';
export const APP_NAME = 'CyBoard';
export const SUPPORT_SUBJECT_DEFAULT = 'CyBoard Support Request';

/**
 * Build a mailto: href with an optional prefilled subject/body.
 * Usage: buildSupportMailto({ subject: 'Upload failed', body: 'Event id: 123' })
 */
export function buildSupportMailto({ subject, body } = {}) {
  const params = [];
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  else params.push(`subject=${encodeURIComponent(SUPPORT_SUBJECT_DEFAULT)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);
  return `mailto:${SUPPORT_EMAIL}?${params.join('&')}`;
}
